import { $api } from "@/utils/fetch.ts";

export const chatModelsQueryOptions = () =>
	$api.queryOptions("get", "/api/chats/models");
